import {Component, DoCheck, OnInit} from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../../auth/api/auth.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  animations: [
    trigger('openCloseNavbar', [
      state(
        'open',
        style({
          width: '256px',
        })
      ),
      state(
        'close',
        style({
          width: '64px',
        })
      ),
      transition('open => close', [animate('0.2s')]),
      transition('close => open', [animate('0.2s')]),
    ]),
    trigger('shrinkExtendContent', [
      state(
        'extend',
        style({
          marginLeft: '64px',
        })
      ),
      state(
        'shrink',
        style({
          marginLeft: '256px',
        })
      ),
      transition('extend => shrink', [animate('0.2s')]),
      transition('shrink => extend', [animate('0.2s')]),
    ]),
  ],
})
export class SidenavComponent implements OnInit, DoCheck {
  isAuthenticated$: Observable<boolean>;
  isAdmin: boolean;
  isExpanded: boolean;

  constructor(private authService: AuthService) {}


  ngOnInit(): void {
    this.isAuthenticated$ = this.authService.isAuthenticated;
  }

  ngDoCheck(): void {
    this.isAdmin = this.authService.isAdmin();
  }

  toggle(): void {
    this.isExpanded = !this.isExpanded;
  }
}
